<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_fees_payment'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Class">
                    <v-select
                      :options="schoolclasses"
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                  <div class="col mt-4 mb-4 justify-content-end d-flex">
                    <router-link to="/feesdefaulters">
                      <b-button class="mx-4" size="lg" variant="info"
                        >Fees Defaulters</b-button
                      ></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="text-center mt-4" v-if="schoolstream != ''">
                <h3>
                  {{ schoolclass.name }}{{ schoolstream.name }}
                  {{ schoolterm.name }} {{ year }}
                </h3>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onTableFiltered"
                  :busy="IsBusy"
                >
                  <template #table-busy>
                    <NoDataMessage :type="emptyStateType" />
                  </template>
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_id)="data">
                    <b class="text-danger">{{
                      data.item.student.student_id
                    }}</b>
                    <br />
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }} <br />
                    <small
                      ><b>{{ data.item.student.student_id }}</b></small
                    >
                  </template>
                  <template #cell(class)="data">
                    {{ data.item.class.name }} {{ data.item.stream.name }}
                  </template>
                  <template #cell(fees)="data">
                    {{ commas(data.item.fees) }}
                  </template>
                  <template #cell(total)="data">
                    {{ commas(data.item.total) }}
                  </template>
                  <template #cell(exemptions)="data">
                    {{ commas(data.item.exemptions) }}
                  </template>
                  <template #cell(optional)="data">
                    {{ commas(data.item.optional) }}
                  </template>
                  <template #cell(online)="data">
                    {{ commas(data.item.online) }}
                  </template>

                  <template #cell(previousbalances)="data">
                    {{ commas(data.item.previousbalances) }}
                    <!-- <b-button @click="pay(data.item.id,data.item.student.student_id,data.item.term,data.item.year,data.item.amountpaid,data.item.payoption,data.item.paydate)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-cash"></i> pay</b-button> -->
                  </template>
                  <template #cell(balance)="data">
                    <span
                      v-if="data.item.bursary.bursarytype == 'Full Bursary'"
                    >
                      0
                    </span>
                    <span
                      v-else-if="
                        data.item.bursary.bursarytype == 'Half Bursary'
                      "
                    >
                      {{
                        commas(
                          Number(
                            (Number(data.item.total) +
                              Number(data.item.previousbalances)) /
                              2,
                          ) -
                            Number(data.item.fees) -
                            Number(data.item.exemptions) -
                            Number(data.item.online),
                        )
                      }}
                    </span>
                    <span v-else-if="data.item.bursary.bursarytype == 'Custom'">
                      {{
                        commas(
                          Number(data.item.bursary.bursaryvalue) +
                            Number(data.item.previousbalances) -
                            Number(data.item.fees) -
                            Number(data.item.exemptions) -
                            Number(data.item.online),
                        )
                      }}
                    </span>
                    <span
                      v-else-if="data.item.bursary.bursarytype == 'Percentage'"
                    >
                      {{
                        commas(
                          Number(
                            (Number(data.item.total) +
                              Number(data.item.previousbalances)) *
                              (data.item.bursary.bursaryvalue / 100),
                          ) -
                            Number(data.item.fees) -
                            Number(data.item.exemptions) -
                            Number(data.item.online),
                        )
                      }}
                    </span>
                    <span v-else>
                      {{
                        commas(
                          Number(
                            Number(data.item.total) +
                              Number(data.item.previousbalances),
                          ) -
                            Number(data.item.fees) -
                            Number(data.item.exemptions) -
                            Number(data.item.online),
                        )
                      }}
                    </span>
                  </template>
                  <template #cell(bursary)="data">
                    <span
                      v-if="data.item.bursary.bursarytype == 'Full Bursary'"
                    >
                      <small class="text-success"
                        ><b>{{ data.item.bursary.bursarytype }}</b></small
                      >
                      <br />
                      {{ commas(data.item.total) }}
                    </span>
                    <span
                      v-else-if="
                        data.item.bursary.bursarytype == 'Half Bursary'
                      "
                    >
                      <small class="text-success"
                        ><b>{{ data.item.bursary.bursarytype }}</b></small
                      >
                      <br />
                      {{ commas(data.item.total / 2) }}
                    </span>
                    <span v-else-if="data.item.bursary.bursarytype == 'Custom'">
                      <small class="text-success"
                        ><b>{{ data.item.bursary.bursarytype }}</b></small
                      >
                      <br />
                      {{ commas(data.item.bursary.bursaryvalue) }}
                    </span>
                    <span
                      v-else-if="data.item.bursary.bursarytype == 'Percentage'"
                    >
                      <small class="text-success"
                        ><b
                          >{{ data.item.bursary.bursarytype }} -
                          {{ data.item.bursary.bursaryvalue }}</b
                        ></small
                      >
                      <br />
                      {{
                        commas(
                          data.item.total *
                            (data.item.bursary.bursaryvalue / 100),
                        )
                      }}
                    </span>
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          add(
                            data.item.id,
                            data.item.student.student_id,
                            data.item.term,
                            data.item.year,
                            data.item.fees.amount,
                            data.item.amountpaid,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.add
                      >
                        <i class="mdi mdi-cash"></i> Pay</b-button
                      >
                      <router-link
                        :to="{
                          path: '/paymentsledger',
                          query: {
                            student_id: data.item.student.student_id,
                            term: data.item.term,
                            year: data.item.year,
                          },
                        }"
                        type="button"
                        class="btn-sm btn btn-primary"
                      >
                        <i class="fas fa-book"></i> Ledger</router-link
                      >
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="add-payment"
        centered
        title="Add School Fees Payment"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="AddPayment">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label
              >Student :
              <small class="text-primary">{{ student }}</small></label
            >
            <v-select
              disabled
              :options="students"
              placeholder="Select Student"
              v-model="student"
              :reduce="(students) => students.student.student_id"
            >
              <template slot="option" slot-scope="option">
                <div>
                  {{ option.student.first_name }}
                  {{ option.student.last_name }} {{ option.class.name }}
                  {{ option.stream.name }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div>
                  {{ option.student.first_name }}
                  {{ option.student.last_name }} {{ option.class.name }}
                  {{ option.stream.name }}
                </div>
              </template>
            </v-select>
            <div class="row">
              <div class="col-md-6">
                <label>Term</label>
                <v-select
                  disabled
                  :options="schoolterms"
                  placeholder="Select Term"
                  v-model="schoolterm"
                  label="name"
                  :reduce="(schoolterms) => schoolterms.id"
                ></v-select>
              </div>
              <div class="col-md-6">
                <label>Year</label>
                <b-form-input
                  disabled
                  v-model="year"
                  type="number"
                ></b-form-input>
              </div>
            </div>
            <label>Fees</label>
            <multiselect
              v-model="fees"
              label="name"
              :options="feescategories"
            ></multiselect>
            <label>Paid Amount</label>
            <b-form-input v-model="amount" type="number"></b-form-input>
            <div class="row">
              <div class="col-md-6">
                <b>Payment Option</b>
                <multiselect
                  v-model="payoption"
                  label="name"
                  :options="paymentoptions"
                ></multiselect>
              </div>
              <div class="col-md-6">
                <b>Pay Date</b>
                <input
                  v-model="paydate"
                  type="date"
                  required
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('add-payment')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="add-previouspayment"
        centered
        title="Add Previous Balance Payment"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="AddPreviousPayment">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <div class="row">
              <div class="col-md-6">
                <label>Term</label>
                <v-select
                  :options="schoolterms"
                  placeholder="Select Term"
                  v-model="schoolterm"
                  label="name"
                  :reduce="(schoolterms) => schoolterms"
                ></v-select>
              </div>
              <div class="col-md-6">
                <label>Year</label>
                <b-form-input v-model="year" type="number"></b-form-input>
              </div>
            </div>
            <label>Fees</label>
            <multiselect
              v-model="fees"
              label="name"
              :options="feescategories"
            ></multiselect>
            <label>Paid Amount</label>
            <b-form-input v-model="amount" type="number"></b-form-input>
            <div class="row">
              <div class="col-md-6">
                <b>Payment Option</b>
                <multiselect
                  v-model="payoption"
                  label="name"
                  :options="paymentoptions"
                ></multiselect>
              </div>
              <div class="col-md-6">
                <b>Pay Date</b>
                <input
                  v-model="paydate"
                  type="date"
                  required
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('add-previouspayment')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import NoDataMessage from "@/components/NoDataMessage.vue";
import { emptyStatesMixin } from "@/state/emptyStatesMixin";
import {
  feescategoryComputed,
  feescategoryMethods,
  feespaymentComputed,
  feespaymentMethods,
  paymentoptionComputed,
  paymentoptionMethods,
  previousbalanceComputed,
  previousbalanceMethods,
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  mixins: [emptyStatesMixin],
  page: {
    title: "Fees Payments",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    NoDataMessage,
  },
  data() {
    return {
      title: "Fees Payments",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Fees Payments", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,

      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student", label: "Student", visible: true },
        { key: "class", label: "Class", visible: true },
        { key: "total", label: " School Fees", visible: true },
        { key: "optional", label: "Optional Fees", visible: true },
        { key: "fees", label: "Amount Paid", visible: true },
        { key: "online", label: "Online payment", visible: true },
        { key: "previousbalances", label: "Previous Balances", visible: true },
        // { key: 'balances', label: 'Previous Balances', visible: true },
        { key: "exemptions", label: "Exemptions", visible: true },
        { key: "balance", label: "Balance", visible: true },
        { key: "actions", label: "Ledger", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      student: "",
      name: "",
      student_id: "",
      schoolterm: "",
      schoolclass: "",
      schoolstream: "",
      schoolstreams: [],
      online: "",
      year: new Date().getFullYear(),
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: "",
      fees: "",
      amount: 0,
      requiresFilter: true,
    };
  },
  computed: {
    ...feespaymentComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    ...feescategoryComputed,
    ...studentComputed,
    ...paymentoptionComputed,
    ...previousbalanceComputed,
    List() {
      return this.feespayments.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.feespayments.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.feespayments.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.fetchFeesPayments();
    this.fetchStudents();
    this.fetchFeesCategories();
    this.fetchPaymentoptions();
    this.fetchPreviousBalances();
    this.TotalRows = this.feespayments.length;
    this.isBusy = false;
    this.payoption = this.paymentoptions.find(
      (option) => option.set_default == 1,
    );
  },
  methods: {
    ...feespaymentMethods,
    ...studentMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    ...paymentoptionMethods,
    ...feescategoryMethods,
    ...previousbalanceMethods,
    add(id, student, schoolterm, year, amount) {
      this.id = id;
      this.student = student;
      this.schoolterm = schoolterm;
      this.year = year;
      this.amount = amount;
      this.$bvModal.show("add-payment");
    },
    pay(id, student, schoolterm, year, amount, payoption, paydate) {
      this.id = id;
      this.student = student;
      this.schoolterm = schoolterm;
      this.year = year;
      this.amount = amount;
      this.payoption = payoption;
      this.paydate = paydate;
      this.$bvModal.show("add-previouspayment");
    },
    commas(x) {
      if (x == null || x == undefined) return "0";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      this.markFiltersApplied();
      this.filterFeesPayments({
        schoolterm: this.schoolterm.id,
        year: this.year,
        schoolclass: this.schoolclass.id,
      });
    },
    async AddPayment() {
      let formData = new FormData();
      formData.append("student", this.student);
      formData.append("schoolterm", this.schoolterm);
      formData.append("year", this.year);
      formData.append("fees", this.fees.id);
      formData.append("amount", this.amount);
      formData.append("paydate", this.paydate);
      formData.append("payoption", this.payoption.id);
      let url = "/addfeespayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.filterFeesPayments({
            schoolterm: this.schoolterm,
            year: this.year,
            schoolclass: this.schoolclass.id,
          });
          this.$bvModal.hide("add-payment");
          this.student = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async fetchAllBalances() {
      let url = "/api/students/balances"; // Update the URL if necessary

      await axios
        .get(url)
        .then((response) => {
          if (response.status === 200) {
            this.balances = response.data.balances; // Assuming the response structure is as expected
            this.$swal({
              title: "Success",
              text: "Balances fetched successfully",
              icon: "success",
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Unable to fetch balances", error);
          this.$swal({
            title: "Error",
            text: "Failed to fetch balances",
            icon: "error",
          });
        });
    },
  },
};
</script>
